import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.png";
import projeImg4 from "../assets/img/game.svg";
import projeImg5 from "../assets/img/img2.png";
import projeImg6 from "../assets/img/ab.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { Link } from 'react-router-dom';
import { useSpring,animated } from "react-spring";
import React ,{useState} from "react";

export const Projects = () => {
  const [flip ,setFlip] = useState(false);
  const props = useSpring({
    to:{opacity :1},
    from:{opacity:0},
    reset: true ,
    reverse: flip ,
    delay: 1000,
    onRest: () => setFlip(!flip),

  })

  const projects = [
    {
      title: "CLM",
      description: "Game",
      
      
      
      imgUrl: projeImg4,
    
      link: "https://play.google.com/store/games?hl=tr&gl=US",

    },
    {
      title: "Game",
      description: "Coming Soon",
      imgUrl: projeImg5,
      link: "https://play.google.com/store/games?hhl=tr&gl=US", 
    },
    {
      title: "Game",
      description: "Game",
      imgUrl: projeImg6,
      link: "https://play.google.com/store/games?hl=tr&gl=US",
    },
    {
      title: "Game",
      description: "Game",
      imgUrl: "",
      link: "https://play.google.com/store/games?hl=tr&gl=US",
    },
    {
      title: "Game",
      description: "Game",
      imgUrl: "",
      link: "https://play.google.com/store/games?hl=tr&gl=US",

    },
    {
      title: "Game",
      description: "Game",
      imgUrl: "",
      link: "https://play.google.com/store/games?hl=tr&gl=US",

    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>
                  All game projects
                 </p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                    <animated.div style={props}>
                      <Row>
                       
                        {
                          projects.map((project, index) => {
                            return (
                              
                                <ProjectCard
                                
                                  href={project.link}

                                  key={index}
                                  
                                  {...project}
                                  
                                  />
                                
                            )
                          })
                        }
                        
                      </Row>
                      </animated.div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      <p></p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p></p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
     
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
